// extracted by mini-css-extract-plugin
export default {"resources":"styles_resources__dfjCZ","body":"styles_body__q7Ne+","warning":"styles_warning__peMMK"};